import BaseStore from './BaseStore';
import { observable, action, configure } from 'mobx';
import axios from 'axios';

import config from './Config';

configure({ enforceActions: 'observed' }) // don't allow state modifications outside actions

class UserModel {
	@observable id = null;
	@observable email = '';
	@observable name = '';

	static properties = ['email', 'name'];

	constructor(props) {
		this.id = props.id || null;
		UserModel.properties.forEach( key => {
			this[key] = props[key];
		});
	}
}

class UserListStore extends BaseStore {
	roles = [];

	constructor(props) {
		super(props);
		this.initialize();
	}

	initialize() {
		return axios.get(config.apis.roles.find, {
                        ...this.auth.getAuthHeaders()
                }).then( (response) => {
			if (response.data) {
				this.roles = response.data;
			}
		});
	}

	loadImplementation(opt) {
		return axios.get(config.apis.user.find, {
			...this.auth.getAuthHeaders()
		}).then( (response) => {
			console.log(response.data);
			this.setItems(response.data);
			return response.data;
		});
	}

	fetchById(id) {
		return axios.get(config.apis.user.findById(id), {
			...this.auth.getAuthHeaders()
		}).then( (response) => {
			console.log(response.data);
			return response.data;
		}).catch( (err) => {
			console.error(err);
			throw err;
		});
	}

	insertImplementation(values) {
		return axios.post(config.apis.user.create, values, {
			...this.auth.getAuthHeaders()
		}).then( (response) => {
			console.log(response.data);
			//users are made admin by default!!!
			this.makeAdmin(response.data);
			return response.data;
		}).catch( (err) => {
			if (err.response && err.response.data && err.response.data.error){
				throw err.response.data.error;
			}
			throw err;
		});
	}

	makeAdmin(values) {
		console.log('Trying to set admin role on save/update');
		let adminRole = this.roles.find( (element) => element.name == 'admin' );
		if (!adminRole){
			return;
		}

		return axios.post(config.apis.roleMappings.create, {
			principalType: 'USER'
			,principalId: values.id
			,roleId: adminRole.id
		}, {
			...this.auth.getAuthHeaders()
		}).then( (response) => {
			console.log(response);
		}).catch( (err) => {
			console.warn(err);
		});
		
	}

	updateImplementation(values) {
		//we're patching, not really replacing the attributes
		return axios.patch(config.apis.user.update(values.id), values, {
			...this.auth.getAuthHeaders()
		}).then( (response) => {
			console.log(response.data);
			//users are made admin by default!!!
			this.makeAdmin(response.data);
			return response.data;
		}).catch( (err) => {
			console.error(err);
			throw err;
		});
	}

	deleteImplementation(id) {
		return axios.delete(config.apis.user.delete(id), {
			...this.auth.getAuthHeaders()
		}).then( (response) => {
			console.log(response.data);
			return response.data;
		}).catch( (err) => {
			console.error(err);
			throw err;
		});
	}
}

export { UserModel, UserListStore };
